var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"article-rating"},_vm._l(([1, 2, 3, 4, 5]),function(value){return _c('i',{key:value,staticClass:"material-icons article-rating-star",on:{"click":function($event){return _vm.onRate(value)}}},[_vm._v(" "+_vm._s(_vm.totalRating >= value ? "star" : "star_outline")+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }